import { render, staticRenderFns } from "./PatchCauses.vue?vue&type=template&id=181500cf"
import script from "./PatchCauses.vue?vue&type=script&lang=js"
export * from "./PatchCauses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports